import React from "react";
import useFileShare from "../fmanlibs/FileShare";
import EditIcon from "../gui/Icons/EditIcon";
import ShareIcon from "../gui/Icons/ShareIcon";
import Menu, { TMenuRow } from "../gui/Menu/Menu";
import { useOverlay } from "../gui/Overlay/OverlayProvider";
import { FMFile } from "../shared/FMFile";
import PhotoIcon from "./Icons/PhotoIcon";
import DeleteIcon from "../gui/Icons/DeleteIcon";
import useDeleteFiles from "../fmanlibs/useDeleteFiles";
import useRenameDlg from "./Rename/RenameDlg";

const FILEMENU_ID = "fileMenu"

export default function FileMenu(props:{file:FMFile}) {
    const {file} = props
    const {deleteFiles} = useDeleteFiles()
    const {rename} = useRenameDlg()
    const {getShare} = useFileShare()
    const onRename = () => rename(props.file)
    const onDelete = () => deleteFiles([props.file])
    const options : TMenuRow<string>[] = [
        {id:"rename",text:"Rename",icon:<EditIcon/>,onClick:onRename},
        {id:"delete",text:"Delete",icon:<DeleteIcon/>,onClick:onDelete},
        {id:"share",text:"Share",icon:<ShareIcon/>, children:getShare([props.file])}
    ]
    if (FMFile.canPreview(props.file)) options.unshift({id:"preview",text:"Preview",icon:<PhotoIcon/>,url:{hash:"/preview/"+file._id}})
    return <Menu options={options} overlayId={FILEMENU_ID}/>
}

export function useFileMenu(){
    const {addOverlay,hasOverlay} = useOverlay()

    const openFileMenu = (e:React.MouseEvent<HTMLDivElement>, row:FMFile) => {
        e.preventDefault()
        if (hasOverlay("fileMenu")) return
        const position = {x:e.clientX,y:e.clientY}
        addOverlay(FILEMENU_ID, {anchor:{anchorPosition:"fixed", position},children:<FileMenu file={row}/>})
    }

    return {openFileMenu}
}